import { useEffect, useState } from 'react'
import { BankFilled, CloseOutlined, ForkOutlined, UserOutlined,
  CreditCardOutlined, DownloadOutlined, CheckCircleFilled, CopyFilled } from '@ant-design/icons'
import { customerService } from 'services'
import { Button, Col, Modal, Row } from 'antd'
import styled from 'styled-components'

const ModalBody = styled.div`
  b {
    display: contents;
  }
  font-size: 15px;
  .content{
    width: 100%;
    @media (max-width:992px){
      flex-direction: column;
    }
    display:flex;
    margin:15px;
    gap:15px;
    .left{
      flex: 2;
      border: 1px solid #ddd;
      border-radius:5px;
      padding: 15px 20px;
      text-align: center;
    }
    .right{
      flex: 3;
      border: 1px solid #ddd;
      border-radius:5px;
      padding: 15px 20px;
      p{
        margin-top: 15px;
        margin-bottom: 15px;
      }
      p:first-child{
        margin-top: unset;
      }
    }
  }
`

const ModalInfoDeposit = ({ open, onCancel, dataConfig, profile }) => {
  const cid = profile?.id;
  const linkQR = `https://img.vietqr.io/image/970416-156101399-print.jpg?amount=&addInfo=TQP${cid}&accountName=NGUYEN%20NGOC%20LINH`;
  const addContent = `TQP${cid}`;
  const linkImage = `qr-${cid}.png`;

  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState(false)
  function onCopy(){
    navigator.clipboard.writeText(addContent);
  }
  function onCheckAddMoney(){
    setLoading(true);
    setMsg(false);
    customerService.checkAddMoney((response) => {
      setLoading(false);
      setMsg(response?.data?.msg);
      if(response?.data?.code === '100'){
        setTimeout(() => location.reload(), 1500);
      }
    })
  }
  function getFooter(){
    if (loading){
      return (
          <p style={{textAlign:'center',color:'red',marginTop:'10px',marginBottom:'10px'}}>Vui lòng chờ, hệ thống đang xử lý...</p>
      )
    }
    return (
      <div style={{marginTop:'10px',marginBottom:'10px',textAlign:'center'}}>
        {msg ? <p style={{marginTop:'8px',marginBottom:'8px',color:'red'}}>{msg}</p> : ''}
        <p style={{textAlign: 'center'}}>
          <Button onClick={onCheckAddMoney} icon={<CheckCircleFilled/>}>
            Xác nhận đã nạp tiền
          </Button>
          <Button onClick={onCancel} icon={<CloseOutlined/>}>
            Thoát
          </Button>
        </p>
      </div>
    )
  }
  function onDownloadFile(){
    fetch(linkQR)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = linkImage;
        link.click();
      })
      .catch(console.error);
  }

  return (
    <Modal
      title={<p style={{ fontSize: '20px', fontWeight: 700 }}>Thông tin chuyển khoản</p>}
      open={open}
      footer={getFooter()}
      onCancel={onCancel}
      width={992}
      maskClosable={false}
    >
      <ModalBody>
        <Row gutter={[5, 5]}>
          <div className="content">
            <div className="left">
              <p><b>Cách 1: Chuyển khoản bằng mã QR</b></p>
              <p>Mở app ngân hàng quét QR code</p>
              <p><img alt="" src={`${linkQR}`}/></p>
              <p>
                <Button onClick={onDownloadFile} icon={<DownloadOutlined/>}>
                  Tải xuống mã QR
                </Button>
              </p>
            </div>
            <div className="right">
              <p style={{textAlign: 'center'}}><b>Cách 2: Chuyển khoản thủ công theo thông tin sau:</b></p>
              <p>- Tên ngân hàng: <b>{dataConfig?.data?.bank_name_deposit}</b></p>
              <p>- Chi nhánh: {dataConfig?.data?.bank_branch_deposit}</p>
              <p>- Tên tài khoản: <b>{dataConfig?.data?.bank_account_deposit}</b></p>
              <p>- Số tài khoản: <b>{dataConfig?.data?.bank_number_deposit}</b></p>
              <p>
                <span>Nội dung chuyển khoản: </span>
                <b>{addContent}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
                <Button onClick={onCopy} icon={<CopyFilled />}>
                  Copy
                </Button>
              </p>
              <p>Ghi chú: Trong đó <b>{profile?.id}</b> là mã tài khoản của bạn</p>
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ModalInfoDeposit
